






import Vue from "vue";

export default Vue.extend({
  name: "v-form-control",
  props: {
    label: {
      type: String
    },
    labelFor: {
      type: String
    }
  }
});
